module.exports = __webpack_public_path__ + "img/surgery-system.cd170e75.png";